import {Component} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {filter} from "rxjs/operators";
import {PrestFiltre,TypeFiltreChar} from "@domain/prestation/prest-filtre";
import {handleResult} from "@share/utils/handle-result";
import {ToastrService} from "ngx-toastr";

/**
 * Composant d'un item de la liste des filtres
 */
@Component({
	host: {'data-test-id': 'filtre-list-item'},
	templateUrl: './filtre-list-item.component.html'
})
export class FiltreListItemComponent extends ListViewItem<PrestFiltre> {
	/** Types de filtres possibles */
	protected readonly TypeFiltreChar = TypeFiltreChar;

	/**
	 * Constructeur
	 */
	constructor(private prestationService: PrestationService,
				private translateService: TranslateService,
				private toastrService: ToastrService,
				private confirmService: ConfirmService) {
		super();
	}

	/**
	 * Évènement de suppression de l'item
	 */
	public deleteFiltre(): void {
		//Popin de confirmation
		this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation')).pipe(filter(isConfirmed => isConfirmed)).subscribe({
			next: () => {
				//Suppression du filtre sur la prestation
				this.prestationService.deletePrestationFiltre(this.liste.extraOptions.idPrestation,this.data)
										.pipe(handleResult(this.translateService,this.toastrService,'global.success.suppression','global.errors.suppression'))
										.subscribe(() => this.liste.extraOptions.refreshListe());
			}
		});
	}
}
